export default function isEmpty(value: string): boolean {
  if (!value) {
    return true;
  }
  return value.replace(/\s/g, '').length === 0;
}
